import { render } from "./hotelTable.vue?vue&type=template&id=1b16a6ac&scoped=true"
import script from "./hotelTable.vue?vue&type=script&lang=js"
export * from "./hotelTable.vue?vue&type=script&lang=js"

import "./hotelTable.vue?vue&type=style&index=0&id=1b16a6ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b16a6ac"

export default script